var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiPopupDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552.838,
    height: 536.071,
    viewBox: "0 0 552.838 536.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_popup_dotted",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_921",
    "data-name": "Tracciato 921",
    d: "M-3.023,53.63-2.4,465.648l7.016,45.906L35.552,513l124.5,2.173,364.8,8.592L528.3,500.03,537,63.057,536.4,28.307,511.617,10.582l-490.648-13L-6.726-2.9Z",
    transform: "matrix(1, -0.017, 0.017, 1, 6.776, 12.272)",
    fill: "#fffdf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1027",
    "data-name": "Tracciato 1027",
    d: "M2.4,53.512,4.439,435.857,7.8,478.585l28.715,1.351,115.566,2.034,339.566,14.937L492,476.564l4.381-253.1L499.76,28.4,472.555,10.487,23.159-1.537.629-4.249Z",
    transform: "matrix(1, -0.017, 0.017, 1, 20.849, 25.408)",
    fill: "none",
    stroke: "#c78b43",
    strokeWidth: 3,
    strokeDasharray: 10,
    opacity: 0.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiPopupDotted);
export default __webpack_public_path__ + "static/media/UI_popup_dotted.4f2a6c57269b2bf88bf1c55e17c421f1.svg";
export { ForwardRef as ReactComponent };